export const excelExportContentFields = {
  news: {
    id: {
      title: 'id',
      selected: false,
    },
    copy_count: {
      title: 'copy_count',
      selected: true,
    },
    content: {
      title: 'content',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    'relation.title': {
      title: 'relation.title',
      selected: true,
    },
    'relation.type': {
      title: 'relation.type',
      selected: false,
    },
    'relation.url': {
      title: 'relation.url',
      selected: false,
    },
    source: {
      title: 'source',
      selected: false,
    },
    title: {
      title: 'title',
      selected: false,
    },
    url: {
      title: 'url',
      selected: true,
    },
    content_tags: {
      title: 'content_tags',
      selected: false,
    },
    republishers: {
      title: 'republishers',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  newsCopy: {
    'relation.title': {
      title: 'relation.title',
      selected: true,
    },
    'relation.url': {
      title: 'relation.url',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    view_count: {
      title: 'view_count',
      selected: true,
    },
  },
  instagram: {
    id: {
      title: 'id',
      selected: false,
    },
    url: {
      title: 'url',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    like_count: {
      title: 'like_count',
      selected: false,
    },
    media_type: {
      title: 'media_type',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    comment_count: {
      title: 'comment_count',
      selected: false,
    },
    content_tags: {
      title: 'content_tags',
      selected: false,
    },
    view_count: {
      title: 'view_count',
      selected: false,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: false,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    follower_count: {
      title: 'follower_count',
      selected: false,
    },
    following_count: {
      title: 'following_count',
      selected: false,
    },
    title: {
      title: 'title',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  instagramComment: {
    id: {
      title: 'id',
      selected: false,
    },
    time: {
      title: 'time',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    like_count: {
      title: 'like_count',
      selected: true,
    },
    reply_count: {
      title: 'reply_count',
      selected: true,
    },
    'post.text': {
      title: 'post.text',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    'post_relation.follower_count': {
      title: 'post_relation.follower_count',
      selected: false,
    },
    'post_relation.following_count': {
      title: 'post_relation.following_count',
      selected: false,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: false,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: false,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  instagramCommentByPost: {
    id: {
      title: 'id',
      selected: false,
    },
    time: {
      title: 'time',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    like_count: {
      title: 'like_count',
      selected: true,
    },
    reply_count: {
      title: 'reply_count',
      selected: true,
    },
    'post.text': {
      title: 'post.text',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    'post_relation.follower_count': {
      title: 'post_relation.follower_count',
      selected: false,
    },
    'post_relation.following_count': {
      title: 'post_relation.following_count',
      selected: false,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: false,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: false,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  instagramStories: {
    id: {
      title: 'id',
      selected: false,
    },
    time: {
      title: 'time',
      selected: true,
    },
    media_type: {
      title: 'media_type',
      selected: true,
    },
    raw_content: {
      title: 'raw_content',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    resource_username: {
      title: 'resource_username',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  twitter: {
    id: {
      title: 'id',
      selected: false,
    },
    username: {
      title: 'username',
      selected: true,
    },
    copy_count: {
      title: 'copy_count',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    media_type: {
      title: 'media_type',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    follower_count: {
      title: 'follower_count',
      selected: true,
    },
    following_count: {
      title: 'following_count',
      selected: true,
    },
    in_reply_to_text: {
      title: 'in_reply_to_text',
      selected: true,
    },
    in_reply_to_username: {
      title: 'in_reply_to_username',
      selected: true,
    },
    like_count: {
      title: 'like_count',
      selected: true,
    },
    mention: {
      title: 'mention',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
    view_count: {
      title: 'view_count',
      selected: true,
    },
    reply_count: {
      title: 'reply_count',
      selected: true,
    },
  },
  virasty: {
    id: {
      title: 'id',
      selected: false,
    },
    username: {
      title: 'username',
      selected: true,
    },
    repost_count: {
      title: 'repost_count',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    post_type: {
      title: 'post_type',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    resource_followers_count: {
      title: 'resource_followers_count',
      selected: true,
    },
    resource_following_count: {
      title: 'resource_following_count',
      selected: true,
    },
    in_reply_to_post_id: {
      title: 'in_reply_to_post_id',
      selected: true,
    },
    reactions_count: {
      title: 'reactions_count',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
    view_count: {
      title: 'view_count',
      selected: true,
    },
    reply_count: {
      title: 'reply_count',
      selected: true,
    },
  },
  telegram: {
    id: {
      title: 'id',
      selected: false,
    },
    description: {
      title: 'description',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: false,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: false,
    },
    member_count: {
      title: 'member_count',
      selected: true,
    },
    message_type: {
      title: 'message_type',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    source: {
      title: 'source',
      selected: true,
    },
    source_relation_title: {
      title: 'source_relation_title',
      selected: true,
    },
    source_relation_username: {
      title: 'source_relation_username',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    view_count: {
      title: 'view_count',
      selected: false,
    },
    content_tags: {
      title: 'content_tags',
      selected: false,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    comment_count: {
      title: 'comment_count',
      selected: false,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  newspaper: {
    id: {
      title: 'id',
      selected: false,
    },
    title: {
      title: 'title',
      selected: true,
    },
    content: {
      title: 'content',
      selected: true,
    },
    page_number: {
      title: 'page_number',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    categories: {
      title: 'categories',
      selected: true,
    },
    content_tags: {
      title: 'content_tags',
      selected: false,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    resource_title: {
      title: 'resource_title',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  nativePlatforms: {
    id: {
      title: 'id',
      selected: false,
    },
    description: {
      title: 'description',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    time: {
      title: 'time',
      selected: true,
    },
    message_type: {
      title: 'message_type',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    member_count: {
      title: 'member_count',
      selected: false,
    },
    source: {
      title: 'source',
      selected: false,
    },
    source_relation_username: {
      title: 'source_relation_username',
      selected: false,
    },
    url: {
      title: 'url',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    view_count: {
      title: 'view_count',
      selected: true,
    },
    content_tags: {
      title: 'content_tags',
      selected: false,
    },
    comment_count: {
      title: 'comment_count',
      selected: false,
    },
    platform: {
      title: 'platform',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: false,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  linkedin: {
    id: {
      title: 'id',
      selected: false,
    },
    time: {
      title: 'time',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    source: {
      title: 'source',
      selected: true,
    },
    like_count: {
      title: 'like_count',
      selected: true,
    },
    share_count: {
      title: 'share_count',
      selected: true,
    },
    comment_count: {
      title: 'comment_count',
      selected: true,
    },
    follower_count: {
      title: 'follower_count',
      selected: false,
    },
    media_type: {
      title: 'media_type',
      selected: false,
    },
    title: {
      title: 'title',
      selected: false,
    },
    username: {
      title: 'username',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    sentiment: {
      title: 'sentiment',
      selected: true,
    },
    top_category: {
      title: 'top_category',
      selected: false,
    },
    'time-date': {
      title: 'time-date',
      selected: true,
    },
    'time-shamsi': {
      title: 'time-shamsi',
      selected: true,
    },
    'time-time': {
      title: 'time-time',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: true,
    },
    profile_type: {
      title: 'profile_type',
      selected: false,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  multiPlatform: {
    id: {
      title: 'id',
      selected: false,
    },
    platform: { title: 'platform', selected: true },
    lang: { title: 'lang', selected: false },
    'time-date': { title: 'time-date', selected: true },
    'time-shamsi': { title: 'time-shamsi', selected: true },
    'time-time': { title: 'time-time', selected: true },
    description: { title: 'description', selected: true },
    url: { title: 'url', selected: true },
    content_tags: { title: 'content_tags', selected: false },
    application_notes: { title: 'application_notes', selected: false },
    'relation.title': { title: 'relation.title', selected: true },
    'relation.influence_category': {
      title: 'relation.influence_category',
      selected: false,
    },
    extracted_mention: { title: 'extracted_mention', selected: false },
    extracted_hashtag: { title: 'extracted_hashtag', selected: false },
    extracted_url: { title: 'extracted_url', selected: false },
    sentiment: { title: 'sentiment', selected: false },
    top_category: { title: 'top_category', selected: false },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
};
